import { targetUnits } from 'src/modules/user-input/targetUnits.ts';
import { CalcMaxDPState } from 'src/modules/user-input/calcMaxDP/types.ts';

export const initialState: CalcMaxDPState = {
    pv: '0.50',
    dpmv: '',
    dpmvUnit: targetUnits.dpmv,
};
